import { createTheme, alpha } from '@mui/material/styles';
import { deepPurple, teal, cyan, pink, grey } from '@mui/material/colors';


const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0c0f1a',
      layer1: '#171b2e',
      paper: '#171b2e',

    },
    primary: {
      main: deepPurple['A700'], // We also have light, dark, and contrastText
    },

    secondary: {
      main: teal['A700'], // We also have light, dark, and contrastText
    },
    contactColors: { //colors for contact avatars
      mutedOrange: '#FFB74D',
      mutedRed: '#FF8A65',
      mutedPurple: '#BA68C8',
      mutedGreen: '#81C784',
      mutedBlue: '#64B5F6',
      mutedGrey: '#90A4AE',
    },
    teamColors: {
      softCoral: '#FF8A80',
      coolBlue: '#64B5F6',
      mintGreen: '#81C784',
      warmAmber: '#FFB74D',
      lilac: '#BA68C8',
      peach: '#FF8A65',
      tealBlue: '#4DB6AC',
      lavender: '#9C27B0',
      skyBlue: '#29B6F6',
      sage: '#66BB6A',
      rose: '#F06292',
      aqua: '#26C6DA',
    },
    customColors: {
      hyperlink: cyan['A200'],
      appBarBackground: '#171b2e',
      phoneStatusActive: teal[400],
      phoneStatusInactive: pink[500],
      phoneStatusDisabled: grey[500],
      callOutcome: '#ff7597',
      callSummaryHighlight: '#ec4899',
      actionItems: '#ffbf69',
      questionsAsked: '#cbf3f0',
      objections: '#f5a4f5ff',
      keywordHighlight: '#06b6d4',
      keyDecisionHighlight: '#cf6679',
      topicHighlight: '#10b981',
      participantAgent: teal['A400'],
      participantCustomer: '#c084fc',
      highlightEnthusiastic: '#ff9800',
      neutralTone: grey[500],
      assistantRegular: cyan['A200'],
      assistantFab: cyan['A200'],
      toggleButtonColor: '#ff4081',
      teamListColor: '#673ab7',
    },

    categoricalColors: {
      metric1: '#b388ff',
      metric2: '#00F5FF',
      metric3: '#b9f6ca',
      metric4: '#80d8ff',
    },

  },
  typography: {
    fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
    h1: { fontSize: '2.5rem', fontWeight: 500 },
    h2: { fontSize: '2rem', fontWeight: 500 },
    h3: { fontSize: '1.75rem', fontWeight: 500 },
    h4: { fontSize: '1.5rem', fontWeight: 500 },
    h5: { fontSize: '1.25rem', fontWeight: 500 },
    h6: { fontSize: '1rem', fontWeight: 500 },
    body1: { fontSize: '1rem' },
    body2: { fontSize: '0.875rem' },
    body3: { fontSize: '0.70rem' },

  },

  components: {
    /*Customized Tooltip */
    MuiTooltip: {
      defaultProps: { arrow: true },
      styleOverrides: {
        tooltip: ({ theme }) => ({
          backgroundColor: alpha(theme.palette.background.default, 0.98),
          color: theme.palette.common.white,
          fontSize: '0.75rem',
          padding: '6px 8px',
          borderRadius: 8,
          border: `1.5px solid ${alpha(theme.palette.common.white, 0.12)}`,
          backdropFilter: 'blur(8px)',
        }),
        arrow: ({ theme }) => {
          const bg = alpha(theme.palette.background.default, 0.98);
          return {
            color: bg, // arrow fill
            '&::before': {
              border: `1.5px solid ${alpha(theme.palette.common.white, 0.12)}`, // outline to match box
            },
          };
        },
      },
    },

  },

});


export default theme;
